import { useState, useCallback } from 'react';
import api from '@/lib/api';
import type { BetaAccessSubmitInput } from '@/lib/api';

interface UseBetaAccessSubmitReturn {
  submit: (input: BetaAccessSubmitInput) => Promise<void>;
  isSubmitting: boolean;
  isSuccess: boolean;
  error: string | null;
}

export function useBetaAccessSubmit(): UseBetaAccessSubmitReturn {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = useCallback(async (input: BetaAccessSubmitInput) => {
    setIsSubmitting(true);
    setError(null);

    try {
      await api.submitBetaAccessRequest(input);
      setIsSuccess(true);
    } catch (err) {
      if (err instanceof Error) {
        setError(err.message);
      } else {
        setError('An unexpected error occurred. Please try again.');
      }
    } finally {
      setIsSubmitting(false);
    }
  }, []);

  return { submit, isSubmitting, isSuccess, error };
}
